<div class="page-layout blank py-8 px-24">
  <p
    class="mat-error"
    *ngIf="
      courierPartnerForm?.get('courier')?.touched &&
      courierPartnerForm?.get('courier')?.invalid
    "
  >
    <error-message
      fieldName="Courier"
      [formControlErr]="courierPartnerForm?.get('courier')"
    ></error-message>
  </p>

  <mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortData($event)"
    fusePerfectScrollbar
  >
    <!-- Company Name Column -->
    <ng-container matColumnDef="courierName">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="25%"
        >Courier</mat-header-cell
      >
      <mat-radio-group [formControl]="courierPartnerForm?.get('courier')">
        <mat-cell
          [ngClass]="
            courierPartnerForm?.get('courier')?.value === rateList
              ? 'selected'
              : ''
          "
          *matCellDef="let rateList"
          fxFlex="25%"
        >
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-radio-button
              (change)="courierPartnerValue.emit(rateList)"
              [value]="rateList"
              disableRipple="true"
            >
              <div fxLayoutAlign="start center">
                <img
                  class="w-60 ml-20 mr-28"
                  src="assets/images/couriers/{{ rateList.baseCourier }}.png"
                  alt="logo"
                />
              </div>
            </mat-radio-button>
          </div>
        </mat-cell>
      </mat-radio-group>
    </ng-container>

    <!--Service name column-->
    <ng-container matColumnDef="courierService">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15%"
        >Service</mat-header-cell
      >
      <mat-cell
        [ngClass]="
          courierPartnerForm?.get('courier')?.value === rateList
            ? 'selected'
            : ''
        "
        *matCellDef="let rateList"
        fxFlex="15%"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <span>{{ rateList?.price?.courierObj?.service }}</span>
          <span *ngIf="rateList?.custom" class="custom_couriers"> Custom </span>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Zone Column -->
    <ng-container matColumnDef="zone">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15%"
        >Pricing Zone</mat-header-cell
      >

      <mat-cell
        [ngClass]="
          courierPartnerForm?.get('courier')?.value === rateList
            ? 'selected'
            : ''
        "
        *matCellDef="let rateList"
        fxFlex="15%"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <span
            *ngIf="rateList?.price?.courierObj?.rateType === 'B2C'"
            class="mr-12 cursor-pointer"
            [ngClass]="{
              'highlight-fg': rateList?.price?.distanceChangeZone
            }"
            matTooltip="{{ rateList?.price?.zone?.label }} - {{
              rateList?.price?.distanceChangeZone
                ? deliveryZoneEDescription
                : rateList?.price?.zone?.description
            }}"
            matTooltipPosition="after"
            >{{ rateList?.price?.zoneName }}</span
          >
          <ng-container *ngIf="rateList?.price?.courierObj?.rateType === 'B2B'">
            <ng-container *ngFor="let zoneList of b2bCourierZones">
              <span
                class="mr-4 cursor-pointer"
                *ngIf="rateList?.price?.pickupZone === zoneList?.key"
                matTooltip="{{ zoneList?.zone }} - {{ zoneList?.description }}"
                matTooltipPosition="after"
                >{{ zoneList?.zone }}
              </span>
            </ng-container>
            <ng-container *ngFor="let zoneList1 of b2bCourierZones">
              <span
                class="mr-12 cursor-pointer"
                *ngIf="rateList?.price?.deliveryZone === zoneList1?.key"
                matTooltip="{{ zoneList1?.zone }} - {{
                  zoneList1?.description
                }}"
                matTooltipPosition="after"
                >to {{ zoneList1?.zone }}</span
              >
            </ng-container>
            <ng-container *ngFor="let zone of zones">
              <span
                class="mr-4 cursor-pointer"
                *ngIf="rateList?.price?.pickupZone === zone?.key"
                matTooltip="{{ zone?.zone }} - {{ zone?.description }}"
                matTooltipPosition="after"
                >{{ zone?.zone }}
              </span>
              <span
                class="mr-12 cursor-pointer"
                *ngIf="rateList?.price?.deliveryZone === zone?.key"
                matTooltip="{{ zone?.zone }} - {{ zone?.description }}"
                matTooltipPosition="after"
                >to {{ zone?.zone }}</span
              >
            </ng-container>
          </ng-container>
          <!-- <mat-icon
            matTooltip="{{ rateList?.price?.zone?.label }} - {{
              rateList?.price?.zone?.description
            }}"
            matTooltipPosition="after"
            class="cursor-pointer"
          >
            info_outline
          </mat-icon> -->
        </div>
      </mat-cell>
    </ng-container>

    <!-- Shipping Charge Column -->
    <ng-container matColumnDef="shippingCharge">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15%"
        >Shipping Charge</mat-header-cell
      >
      <mat-cell
        [ngClass]="
          courierPartnerForm?.get('courier')?.value === rateList
            ? 'selected'
            : ''
        "
        *matCellDef="let rateList"
        fxFlex="15%"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <ng-container *ngIf="rateList?.price?.courierObj?.rateType === 'B2C'">
            <span
              fxShow
              fxHide.lt-md
              class="mr-12 cursor-pointer"
              [matTooltip]="rateList.price | breakupDetails"
              matTooltipPosition="after"
              color="mat-blue"
            >
              {{
                rateList?.price?.price | RupeePaise: "rupee" | currency: "INR"
              }}
            </span>

            <span
              fxHide.gt-sm
              class="mr-12 cursor-pointer"
              (click)="shippingChargeInfo(rateList, 'shipping charge details')"
              color="mat-blue"
            >
              {{
                rateList?.price?.price | RupeePaise: "rupee" | currency: "INR"
              }}
            </span>

            <!-- <mat-icon
            fxShow
            fxHide.lt-md
            [matTooltip]="rateList.price | breakupDetails"
            color="mat-blue"
            matTooltipPosition="after"
            class="cursor-pointer"
          >
            info_outline
          </mat-icon>

          <mat-icon
            fxHide.gt-sm
            color="mat-blue"
            class="cursor-pointer"
            (click)="shippingChargeInfo(rateList, 'shipping charge details')"
          >
            info_outline
          </mat-icon> -->
          </ng-container>
          <ng-container *ngIf="rateList?.price?.courierObj?.rateType === 'B2B'">
            <span
              class="mr-12 cursor-pointer accent-fg"
              (click)="shippingChargeInfo(rateList, 'shipping charge details')"
              color="mat-blue"
            >
              {{
                rateList?.price?.price | RupeePaise: "rupee" | currency: "INR"
              }}
            </span>
          </ng-container>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Charged Weight Column -->
    <ng-container matColumnDef="chargedWeight">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15%"
        >Charged Weight</mat-header-cell
      >
      <mat-cell
        [ngClass]="
          courierPartnerForm?.get('courier')?.value === rateList
            ? 'selected'
            : ''
        "
        *matCellDef="let rateList"
        fxFlex="15%"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <span
            fxShow
            fxHide.lt-md
            class="mr-12 cursor-pointe"
            [matTooltip]="rateList.price | weightDetails"
            matTooltipPosition="after"
          >
            {{
              rateList?.price?.deadWeight > rateList?.price?.volWeight
                ? (rateList?.price?.deadWeight | weightConversionTo: "kg")
                : (rateList?.price?.weightCharged | weightConversionTo: "kg")
            }}
            Kg
          </span>
          <span
            fxHide.gt-sm
            class="mr-12 cursor-pointe"
            (click)="shippingChargeInfo(rateList, 'charged weight details')"
          >
            {{
              rateList?.price?.deadWeight > rateList?.price?.volWeight
                ? (rateList?.price?.deadWeight | weightConversionTo: "kg")
                : (rateList?.price?.volWeight | weightConversionTo: "kg")
            }}
            Kg
          </span>
          <!-- <mat-icon
            fxShow
            fxHide.lt-md
            [matTooltip]="rateList.price | weightDetails"
            color="mat-blue"
            matTooltipPosition="after"
            class="cursor-pointer"
          >
            info_outline
          </mat-icon>

          <mat-icon
            fxHide.gt-sm
            color="mat-blue"
            class="cursor-pointer"
            (click)="shippingChargeInfo(rateList, 'charged weight details')"
          >
            info_outline
          </mat-icon> -->
        </div>
      </mat-cell>
    </ng-container>

    <!-- TAT Column -->
    <ng-container matColumnDef="tat">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15%">
        TAT
        <mat-icon
          [matTooltip]="tatDescription"
          matTooltipPosition="after"
          class="cursor-pointer"
        >
          info_outline
        </mat-icon>
      </mat-header-cell>
      <mat-cell
        [ngClass]="
          courierPartnerForm?.get('courier')?.value === rateList
            ? 'selected'
            : ''
        "
        *matCellDef="let rateList"
        fxFlex="15%"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <span class="mr-12">
            {{ rateList?.price?.tat | tat }}
          </span>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="rateTableHeader"></mat-header-row>
    <mat-row *matRowDef="let row; columns: rateTableHeader"></mat-row>
  </mat-table>
</div>
